interface IntegrationNotFoundCardProps {
  email: string;
}

export default function IntegrationNotFoundCard({ email }: IntegrationNotFoundCardProps) {
  return (
    <div className="flex flex-col justify-center items-center w-full">
      <span className="font-semibold mb-1">Wrong Inbox...</span>
      <div className="flex flex-col gap-4 w-full">
        <span className="text-typography-grey text-center block break-words max-w-full">
          You are trying to use Tekst on {email}, which is not a connected inbox.
        </span>
        <span className="text-typography-grey text-center block break-words max-w-full">
          Please try a different inbox.
        </span>
      </div>
    </div>
  );
}
